// src/lib/filters/types.ts
import type { ContactFilters } from '@/types/contact';

export type FilterOperator =
  | 'eq'
  | 'neq'
  | 'like'
  | 'ilike'
  | 'gt'
  | 'lt'
  | 'gte'
  | 'lte'
  | 'before'
  | 'after'
  | 'between'
  | 'is';

export type CustomFieldDataType = 'text' | 'number' | 'date' | 'boolean' | 'select';

export interface CustomFieldDefinition {
  id: string;
  label: string;
  data_type: CustomFieldDataType;
  workspace_id: string;
  created_at?: string;
}

export interface FilterFieldOption {
  value: string;
  label: string;
  table: string;
  // 'existence' = a computed presence field (e.g. next_scheduled_event): only
  // Is Empty / Is Not Empty are meaningful; no value input.
  type: 'text' | 'datetime' | 'number' | 'boolean' | 'existence';
  isCustomField?: boolean;
  customFieldId?: string;
}

/**
 * Maps custom field data types to filter field types
 */
export function mapCustomFieldTypeToFilterType(
  dataType: CustomFieldDataType
): 'text' | 'datetime' | 'number' | 'boolean' {
  switch (dataType) {
    case 'text':
    case 'select':
      return 'text';
    case 'number':
      return 'number';
    case 'date':
      return 'datetime';
    case 'boolean':
      return 'boolean';
    default:
      return 'text';
  }
}

/**
 * Converts custom field definition to filter field option
 */
export function customFieldToFilterOption(field: CustomFieldDefinition): FilterFieldOption {
  return {
    value: `custom_field:${field.id}`,
    label: field.label,
    table: 'custom_field',
    type: mapCustomFieldTypeToFilterType(field.data_type),
    isCustomField: true,
    customFieldId: field.id,
  };
}

export interface QueryBuilder {
  addCondition: (field: string, operator: FilterOperator, value: string) => QueryBuilder;
  addSearchTerm: (term: string) => QueryBuilder;
  addFilterGroup: (conditions: any[], type?: 'AND' | 'OR') => QueryBuilder;
  build: () => Promise<any>;
}

export interface FilterValidator {
  validate: (filter: ContactFilters) => boolean;
  getErrors: () => string[];
}
